<template>    
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container d-flex flex-column">
                <header class="mdc-top-app-bar position-static">
                    <div class="mdc-top-app-bar__row">
                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
                            <a class="material-icons mdc-top-app-bar__navigation-icon" @click="routerGoPrev()">arrow_back</a>
                        </section>
                        
                        <section class="mdc-top-app-bar__section title">
                            <div class="mdc-top-app-bar__title">
                                <!-- {{paperName}} -->
                                {{$t('998')}}
                            </div>
                        </section>

                        <section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
                            <a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
                        </section>
                        
                    </div>

                    <result-tab @setViewTab="setViewTab"></result-tab>
                    
                </header>
                <div class="flex-grow-1">


                    <div class="t-body1">
                        <div class="title-txt">
                            {{paperName}}
                            </div>
                    </div>


                    <component 
                        :is="tabType"
                        :periodPolicy="periodPolicy"
                        :summary="summary"
                        :pointPolicy="pointPolicy"
                        :badges="badges"
                    ></component>
                </div>
                
                
            </div>
        </div>
        <router-view></router-view>
    </div>

</template>

<script>
/**
 * 단독 시험 나의 시험 결과 상세 메인 컴포넌트(independent my exam result view main component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import examApi from '@/api/examApi.js'
import {examMixin} from '@/mixins/exam.js'
import ResultTab from './view/ResultTab'
import ViewResultMy from './view/ResultMy'
import ViewInformation from './view/Information'
import ViewRewardMy from './view/RewardMy'

export default {
    data() {
        return {
            tabType: 'ResultMy',
            examineeId: null,
            paperData: null,
            periodPolicy: null,
            summary: '',
            pointPolicy: null,
            badges: null,
            paperName : ''
        }
    },

    components: {
        'result-tab': ResultTab,
        'Information': ViewInformation,
        'RewardMy': ViewRewardMy,
        'ResultMy' : ViewResultMy,
    },
    mixins: [examMixin],

    mounted() {
        let responseData = null
        this.examineeId = this.$route.params.examineeId
        let params = {
            examineeId: this.examineeId,
            application: true
        }

        // get examinee view information
        examApi.independentExamineeExamView(params).then((response) => {
            this.paperData = response.data.data
            this.paperName = this.paperData.name
            this.periodPolicy = this.paperData.period
            this.summary =  this.paperData.summary
            this.pointPolicy = this.paperData.point
        })

        // get exam badge list
        examApi.badges(params).then((response) => {
            this.badges = response.data.data
        })

    },

    methods: {
        setViewTab(tabType) {
            this.tabType = tabType
        },

    }
}
</script>
<style scoped>
.title-txt{color: #212121; padding: 1.15rem 0 0 1.15rem; font-weight: 600;}
</style>